// 调账

import { HttpFuelExtraList, SystemDelivery, HttpGetSysCarrierServiceAccount } from '@/service/costbilling';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            // Tabs: {show: true},
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            systemServiceList:[],
        };
    },
    created(){
        // HttpGetSysCarrierServiceAccount()
        // // SystemDelivery()
        // .then(res=>{
        //     this.systemServiceList = res.data.map(res=>{
        //         return {
        //             value: res.carrierServiceCode,
        //             // label: `${res.carrierServiceCode}(${res.carrierServiceName})`
        //             label: res.carrierServiceCode
        //         }
        //     })
        // })
    },
    methods: {
        ajaxRequest: HttpFuelExtraList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'costbillingfuelextraUpdate',
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'costbillingfuelextraUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;

            }
        },
        getOperateNodeMap(row) {
            const { id,status } = row;
            return [
                {
                    label: "编辑",
                    params: id,
                    operate: "edit",
                    show: true
                },
            ];
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getCarrierAllList', 'getCarrierServiceAllList']),
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },

            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.expresspackage.service_code', { defaultValue: "承运商" }),
                    tag: 'Select',
                    key: 'EQ_carrierCode',
                    options: [
                        {label:'FedEx',value:'FedEx'},
                        {label:'FedEx Freight',value:'FedEx Freight'},
                        {label:'UPS',value:'UPS'}
                    ],
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: this.$t('fbb.carrieraccount.carrieraccount_service',{defaultValue:'承运商服务'}),
                    key: 'EQ_webCarrierServiceName',
                    tag: 'Input',
                    show: true,
                },
                {
                    label: '系统承运商服务',
                    key: 'EQ_carrierServiceCode',
                    tag: 'Select',
                    options:this.getCarrierServiceAllList.map(item=>{
                        return {
                            value: item.attach.carrierServiceCode,
                            label: item.label,
                        }
                    }),
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: "状态",
                    key: 'EQ_status',
                    tag: 'vSelect',
                    options: [
                        {label:"启用",value:1},
                        {label:"停用",value:0},
                    ],
                },
                {
                    label: this.$t('fbb.bill.freeze_createdat', { defaultValue: "创建日期" }),
                    tag: 'vDatepicker',
                    style: "width:200px",
                    key: 'BT_createdAt',
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                }
            ]
        },
        columns() {
            return [
                // {
                //     type: 'selection',
                //     width: 40,
                //     align: 'center',
                //     formName: 'id'
                // },
                {
                    title: this.$t('global.common.operate', { defaultValue: "操作" }),
                    width: 100,
                    render: this.getOperateNodes
                },
                {
                    title: '承运商',
                    key: 'carrierCode',
                },
                {
                    title: '国别',
                    render: (h, {row})=>{
                        return row.country || '--'
                    }
                },
                {
                    title: '承运商服务',
                    key: 'webCarrierServiceName',
                },
                {
                    title: '系统承运商服务',
                    key: 'carrierServiceCode',
                },
                {
                    title: '状态',
                    key: 'status',
                    render:(h,{row})=>{
                        return <div>{row.status == 0 ? '停用':'启用'}</div>
                    }
                },
                {
                    title: '创建人',
                    key: 'createdName',
                },
                {
                    title: '创建时间',
                    key: 'createdAt',
                }];
        },
    },
};




